import React from 'react';
import { formatDate, formatPrice, timeDiff } from '../../utils/Common';

const PaymentTypeItemBank = (props) => {
  const {
    ptData
  } = props;


  return (
    <>

      <div className="border-b-[1px] text-center text-sm border-solid  border-[#E7EBF4] py-[13px] font-nunito grid grid-cols-3 items-start">
        <div className='text-left  text-[#000] font-[600]'>
          {ptData?.account_name}
        </div>
        <div className='text-center  text-[#000] font-[600]'>
          {ptData?.account_number}

        </div>
        <div className='text-right  text-[#000] font-[600]'>
          {formatPrice(ptData?.amount)}
        </div>
      </div>

    </>
  );
};
PaymentTypeItemBank.defaultProps = { className: null };
export default PaymentTypeItemBank;
